<script>
import { downloadCsv } from "@/utils/download";

export default {
  name: "testScoreDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    id: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      show: false,
      loading: false,
      list: [],
    };
  },
  watch: {
    visible(val) {
      this.show = val;
      if (val) {
        this.getDetail();
      }
    },
  },
  mounted() {
    this.show = this.visible;
  },
  methods: {
    getDetail() {
      this.loading = true;
      this.$cloud
        .get("examination/test/score", { testId: this.id })
        .then((res) => {
          this.list = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      console.log("关闭");
      this.$emit("update:visible", false);
    },
    closed() {
      this.list = [];
    },
    handleExport() {
      console.log("导出成绩");
      let data = [["姓名", "试卷名", "得分", "状态"]];
      this.list.forEach((x) => {
        data.push([x.user.username, x.paper.name, x.score, x.statusName]);
      });
      downloadCsv(data, this.title + "成绩导出");
    },
  },
};
</script>

<template>
  <div>
    <el-dialog
      :title="title + '-成绩查看'"
      :visible.sync="show"
      width="600px"
      @closed="closed"
      :before-close="handleClose"
    >
      <div class="p-6" v-loading="loading">
        <p>成绩列表</p>
        <el-table :data="list" style="width: 100%">
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="user.username" label="用户名">
          </el-table-column>
          <el-table-column prop="paper.name" label="试卷名"> </el-table-column>
          <el-table-column prop="score" label="分数"> </el-table-column>
          <el-table-column prop="statusName" label="状态"> </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleExport" type="primary">导 出</el-button>
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped></style>
